import CheckIcon from '@mui/icons-material/Check';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, Checkbox, MenuItem, Select, Typography } from '@mui/material';
import React from 'react';

import { CheckboxSelectFieldProps } from './CheckboxSelectField.types';
import i18n from 'FRONTEND/utils/i18n';


const CheckboxSelectField = ({
  options,
  selectedValues,
  onChange,
  placeholder = i18n._('No filter applied'),
  selectedPlaceholder,
  isLoading = false,
  showSelectAll = true,
  selectAllLabel = i18n._('Select/Unselect all'),
  sx,
  fullWidth = false,
}: CheckboxSelectFieldProps) => {
  const allValues = options.map(option => option.value);

  const handleSelectAll = () => {
    if (selectedValues.length === allValues.length) {
      onChange([]);
    } else {
      onChange(allValues);
    }
  };

  const handleItemSelected = (value: string, checked: boolean) => {
    const newValues = checked ? [...selectedValues, value] : selectedValues.filter(item => item !== value);
    onChange(newValues);
  };

  const placeholderDisplayString = selectedValues.length === 0 ? placeholder : selectedPlaceholder ? `${selectedPlaceholder} (${selectedValues.length})` : `${placeholder} (${selectedValues.length})`;

  return (
    <Select
      multiple
      displayEmpty
      fullWidth={fullWidth}
      value={selectedValues}
      disabled={isLoading}
      renderValue={() => (
        <Typography color={selectedValues.length > 0 ? 'primary.main' : 'text.primary'}>
          {placeholderDisplayString}
        </Typography>
      )}
      sx={{
        height: 40,
        borderRadius: '50vh',
        ...sx,
      }}
    >
      {showSelectAll && (
        <MenuItem value='' onClick={handleSelectAll} sx={{ justifyContent: 'space-between', pl: 2 }}>
          <Typography
            variant='subtitle2'
            pl={1}
            color={selectedValues.length === allValues.length ? 'primary' : 'text.primary'}
          >
            {selectAllLabel}
          </Typography>
          <Checkbox
            checked={selectedValues.length === allValues.length}
            indeterminate={selectedValues.length > 0 && selectedValues.length < allValues.length}
            onChange={handleSelectAll}
            size='small'
            icon={<Box component='span' p={1} />}
            checkedIcon={<CheckIcon />}
            indeterminateIcon={<RemoveIcon />}
          />
        </MenuItem>
      )}
      {options.map((option) => (
        <MenuItem
          key={option.value}
          onClick={() => handleItemSelected(option.value, !selectedValues.includes(option.value))}
          sx={{ justifyContent: 'space-between' }}
        >
          <Typography
            variant='subtitle2'
            pl={1}
            color={selectedValues.includes(option.value) ? 'primary' : 'text.primary'}
          >
            {option.label}
          </Typography>
          <Checkbox
            checked={selectedValues.indexOf(option.value) > -1}
            onChange={(e) => handleItemSelected(option.value, e.target.checked)}
            size='small'
            icon={<Box component='span' p={1} />}
            checkedIcon={<CheckIcon />}
          />
        </MenuItem>
      ))}
    </Select>
  );
};

export default CheckboxSelectField;
